import React from "react";
import { Content } from "../../components/light/Content";
import { Helmet } from "react-helmet";

const list = [
  "អ្នកលក់ត្រូវផ្តល់ព័ត៌មានអំពីប្រវត្តិរូបរបស់ខ្លួនដោយត្រឹមត្រូវ និងពិតប្រាកដ។",
  "កិច្ចព្រមព្រៀងនេះមានសុពលភាពបន្តរហូតដល់មានការកែប្រែណាមួយដែលប្រព័ន្ធនឹងជូនដំណឹងតាមកម្មវិធីទូរស័ព្ទ។",
  "អ្នកលក់យល់ព្រមដាក់លក់ និងផ្សព្វផ្សាយទំនិញនៅលើគេហទំព័រ និងកម្មវិធីទូរស័ព្ទដោយស្វ័យប្រវត្តិ ពេលអ្នកលក់ប្រើប្រព័ន្ធដើម្បីបញ្ចូលព័ត៌មានទំនិញនិងហាងអ្នកលក់។ អ្នកលក់ត្រូវអនុវត្តតាមការណែនាំរបស់ប្រព័ន្ធ ក្នុងការបញ្ចូលទំនិញ និងរៀបចំទំនិញពេលមានការបញ្ជាទិញក្នុងរយៈពេលមិនលើសពី ១ ម៉ោងធ្វើការ ប្រសិនបើទំនិញត្រូវបានរក្សាទុកនៅទីតាំងរបស់អ្នកលក់។",
  "ទំនិញរបស់អ្នកលក់ត្រូវតែជាទំនិញស្របច្បាប់នៃព្រះរាជាណាចក្រកម្ពុជា។ អ្នកលក់ត្រូវមានសិទ្ធិចែកចាយផលិតផល និងកាន់កាប់កម្មសិទ្ធិបញ្ញាលើទំនិញទាំងនោះ។ ប្រព័ន្ធមិនទទួលខុសត្រូវចំពោះសកម្មភាព ឬបណ្តឹងណាមួយពីភាគីទីបីចោទប្រកាន់អ្នកលក់ឡើយ។ ប្រព័ន្ធមានសិទ្ធិដកទំនិញរបស់អ្នកលក់ចេញពីគេហទំព័រនិងកម្មវិធីទូរស័ព្ទ ឬឃ្លាំងក្រុមហ៊ុន ប្រសិនបើមានការទាមទារ ឬចំណាត់ការស្របច្បាប់ណាមួយ។ ប្រព័ន្ធក៏មានសិទ្ធិបដិសេធទំនិញណាដែលក្រុមហ៊ុនរកឃើញថាមិនសមស្របសម្រាប់ការដាក់លក់ផងដែរ។",
  "អ្នកលក់មានសិទ្ធិកំណត់តម្លៃផលិតផលរបស់ខ្លួន។ ទោះជាយ៉ាងណា ប្រព័ន្ធមានសិទ្ធិបដិសេធតម្លៃដែលមិនសមហេតុផល និងអាចកំណត់ តម្លៃផ្តល់ជូនអតិបរមា (Maximum Offer Price) សម្រាប់ទំនិញណាមួយ។",
  "ប្រសិនបើទម្ងន់ ឬទំហំដែលអ្នកលក់បញ្ចូលក្នុងប្រព័ន្ធ ខុសពីទម្ងន់ ឬទំហំពិតប្រាកដ ប្រព័ន្ធនឹងគិតថ្លៃដឹកជញ្ជូនបន្ថែមពីអ្នកលក់ ដោយផ្អែកលើការគណនាថ្លៃដឹកជញ្ជូនតាមប្រព័ន្ធ។",
  "ប្រសិនបើអ្នកលក់ដាក់ស្តុកទំនិញនៅឃ្លាំងក្រុមហ៊ុន ក្រុមហ៊ុនទទួលខុសត្រូវចំពោះការបាត់បង់ ឬការខូចខាតស្តុក ហើយនឹងសងសំណងតាមតម្លៃដែលបានព្រមព្រៀង។ ទោះយ៉ាងណា ក្រុមហ៊ុនមិនទទួលខុសត្រូវចំពោះការខូចខាតឬសំណឹកដោយធម្មជាតិដែលកើតឡើងពីការស្តុករយៈពេលយូរ ឬការតាំងបង្ហាញទំនិញឡើយ។ អ្នកលក់អាចប្រើប្រព័ន្ធដើម្បីបង្កើតព័ត៌មានដាក់ស្តុកមុនពេលផ្ញើមកហើយក៏អាចបង្កើតព័ត៌មានដកស្តុកទៅវិញមុននឹងមកយកស្តុកទៅវិញតាមប្រព័ន្ធដើម្បីជួយសម្រួលការងារនិងងាយស្រួលក្នុងការផ្ទៀងផ្ទាត់។ ប្រព័ន្ធអាចមិនទទួលដាក់ឬដកស្តុកណាដែលមិនមានការបង្កើតព័ត៌មានជាមុន។ ក្រុមហ៊ុនមានសិទ្ធិដកចេញទំនិញដែលមិនអាចប្រើប្រាស់បាន ទំនិញរកឃើញថាហាមឃាត់និងខុសច្បាប់ ខូចគុណភាព ខូចខាត ផុតកំណត់ ឬមូលហេតុផ្សេងៗដែលប្រព័ន្ធចាំបាច់ត្រូវដកចេញវិញ។ ដោយសារប្រព័ន្ធគ្រប់គ្រងស្តុកមានភាពស្មុគស្មាញ ការរាប់ស្តុកនៅឃ្លាំងមិនអាចអនុវត្តបានទេ។ ឃ្លាំងមានខ្យល់ចេញចូលធម្មជាតិ ប៉ុន្តែមិនមានម៉ាស៊ីនត្រជាក់ទេ។",
  `
    ប្រព័ន្ធផ្តល់មធ្យោបាយតភ្ជាប់រវាង អ្នកលក់ អ្នកទិញ ប្រតិបត្តិករ និងអ្នកដឹកជញ្ជូន ដើម្បីធានាថាការទិញ លក់ និងការបំពេញការបញ្ជាទិញមានសុវត្ថិភាព និងងាយស្រួល ប្រព័ន្ធទទួលខុសត្រូវ ទទួលប្រាក់ពីអ្នកទិញ ទូទាត់ប្រាក់ទៅអ្នកលក់ និងប្រតិបត្តិករនិងអ្នកដឹកជញ្ជូនក្រោយពីដកកម្រៃ។ អ្នកលក់យល់ព្រមថាតម្លៃអ្នកលក់ Seller Offer Price (SOP) គឺជាចំនួនទឹកប្រាក់ដែលអ្នកលក់នឹងទទួលបាន (ដកថ្លៃទៅយកទំនិញ Pickup ប្រសិនបើមាន)។ អ្នកលក់ក៏យល់ព្រមថាតម្លៃអ្នកទិញ App Offer Price (AOP) រួមមានតម្លៃទំនិញ និងថ្លៃសេវាពាក់ព័ន្ធទាំងអស់ លើកលែងតែថ្លៃដឹកជញ្ជូន។ ថ្លៃសេវារបស់ប្រព័ន្ធរួមមាន៖
    - ថ្លៃបច្ចេកវិទ្យា និងសេវាកម្ម៖ គិតពីអ្នកទិញ 15% នៃ SOP
    - ថ្លៃវេចខ្ចប់ទំនិញ៖ 0.25 ដុល្លារ/ទំនិញ សម្រាប់ស្វែងរក ពិនិត្យ និងវេចខ្ចប់
    - ថ្លៃទៅយកទំនិញ៖ 0.30 ដុល្លារ/ទំនិញ គិតពីអ្នកលក់
    - ថ្លៃដាក់ស្តុកក្នុងឃ្លាំង៖ 0.50 ដុល្លារ/ម៉ែត្រគូប/ថ្ងៃ
    - ថ្លៃរៀបទំនិញចូលស្តុក៖ 0.05 ដុល្លារ/ទំនិញ សម្រាប់ការបើកកញ្ចប់ ពិនិត្យ វាស់វែង បិទស្លាក និងដាក់ស្តុក
    - ថ្លៃដកស្តុក៖ 0.05 ដុល្លារ/ទំនិញ សម្រាប់ប្រមូល វេចខ្ចប់ និងបញ្ជូនត្រឡប់ទៅអ្នកលក់វិញ
    - អ្នកលក់ក៏អាចស្នើទទួលបានថ្លៃសេវាពិសេសសម្រាប់ផលិតផលក្នុងស្រុកឬសម្រាប់ការងារសហការជួយផ្សព្វផ្សាយប្រព័ន្ធ។
  `,
  "អ្នកលក់យល់ព្រមដោយស្វ័យប្រវត្តិចំពោះថ្លៃសេវា និងការគិតថ្លៃទាំងអស់របស់ប្រព័ន្ធ។",
  "ប្រាក់ដែលទទួលពីអ្នកទិញ អាចដកបានក្រោយការដឹកជញ្ជូនរយៈពេល ១០ ថ្ងៃ ដោយសារអ្នកទិញមានសិទ្ធិប្រគល់ទំនិញវិញក្នុងរយៈពេល ៥ ថ្ងៃ។ ប្រព័ន្ធនឹងដំណើរការទូទាត់ប្រាក់ក្នុងរយៈពេល ៧ ថ្ងៃធ្វើការ បន្ទាប់ពីទទួលសំណើដកប្រាក់។",
  "ដើម្បីការពារការបោកប្រាស់ក្នុងការប្រគល់ទំនិញវិញ ប្រព័ន្ធតម្រូវឲ្យអ្នកទិញផ្តល់រូបថត ឬវីដេអូបញ្ជាក់ពីបញ្ហានៃទំនិញមុនពេលអនុម័តការប្រគល់វិញ។",
  "អ្នកលក់ត្រូវចូលប្រើប្រព័ន្ធ ដើម្បីដាក់សំណើសុំការទូទាត់ប្រាក់បានពីការលក់។",
  "អ្នកលក់ទទួលខុសត្រូវលើការបង់ពន្ធចំពោះអាជីវកម្មផ្ទាល់ខ្លួនបើតម្រូវដោយ អាជ្ញាធរពន្ធដារកម្ពុជា ក្រុមហ៊ុនសន្មតថា តម្លៃដែលអ្នកលក់កំណត់បានរួមបញ្ចូលអាករលើតម្លៃបន្ថែម (VAT) រួចហើយបើអ្នកលក់មានលក្ខខណ្ឌ VAT ក្នុងអាជីវកម្មរបស់ខ្លួន ក្រុមហ៊ុនអាចចេញវិក្កយបត្រជូនអ្នកលក់បានតែសម្រាប់ថ្លៃសេវាដែលក្រុមហ៊ុនបានទទួលពីអ្នកលក់តែប៉ុណ្ណោះ។ អ្នកលក់ត្រូវកត់ត្រាចំនួនប្រាក់ដែលបានទទួល (ឧទាហរណ៍ 7.95 ដុល្លារ) ជាចំណូលលក់សម្រាប់គោលបំណងពន្ធ។",
  "ក្រុមហ៊ុនមានសិទ្ធិ បិទហាងរបស់អ្នកលក់ក្នុងប្រព័ន្ធ បញ្ចប់កិច្ចព្រមព្រៀងនេះ ដកទំនិញនៅក្នុងឃ្លាំងទុកជាកម្មសិទ្ធិក្រុមហ៊ុនឬបោះបង់ចោល រឹបអូសសមតុល្យរបស់អ្នកលក់ដើម្បីទូទាត់បំណុល ប្រសិនបើអ្នកលក់ ដាក់លក់ទំនិញខុសច្បាប់ មិនទូទាត់ថ្លៃសេវាលើសពី ៣ ខែ ឬមិនមានសកម្មភាពលើសពី ១២ ខែ។ បើសមតុល្យមិនគ្រប់ ក្រុមហ៊ុនអាចរឹបអូស និងលក់ស្តុករបស់អ្នកលក់ដើម្បីទូទាត់បំណុល។",
  "ប្រសិនបើ អ្នកលក់ មិនបានស្នើសុំដកប្រាក់នៅជាមួយក្រុមហ៊ុនដែលបានពីការលក់ ឬទូទាត់បំណុលជំពាក់ក្រុមហ៊ុន រយៈពេលលើសពី ២ ឆ្នាំជាប់គ្នា ក្រុមហ៊ុនមានសិទ្ធិទូទាត់កាត់កងនិងលុបទឹកប្រាក់នៅជាមួយក្រុមហ៊ុនដែលបានពីការលក់ ហើយចាត់ទុកជាចំណូលក្រុមហ៊ុន។ អ្នកលក់ នឹងបាត់បង់សិទ្ធិក្នុងការទាមទារទឹកប្រាក់ដែលបានលុបចោល ហើយក្រុមហ៊ុនមិនមានកាតព្វកិច្ចទូទាត់ទឹកប្រាក់នោះឡើយ។",
];

const khmerNumber = [
  "១",
  "២",
  "៣",
  "៤",
  "៥",
  "៦",
  "៧",
  "៨",
  "៩",
  "១០",
  "១១",
  "១២",
  "១៣",
  "១៤",
  "១៥",
  "១៦",
  "១៧",
  "១៨",
  "១៩",
  "២០",
];

export function AgreementScreen() {
  return (
    <Content>
      <Helmet>
        <style>
          {`.container-l192 {
                width: 100% !important;
                max-width: 1000px !important;
                margin: 0 auto !important;
                padding: 1rem 1.5rem !important;
                box-sizing: border-box !important;
            }

            .container-l192 p {
                line-height: 1.7;
                margin-bottom: 0.75rem;
            }

            .container-l192 * {
                font-family: "Aptos", Calibri, Arial, Helvetica, sans-serif;
                font-size: 11pt;
            }

            .container-l192 h1 {
                font-size: 1.6rem;
                text-align: center;
                margin-bottom: 0.25rem;
            }

            .container-l192 .version {
                text-align: center;
                margin-bottom: 1.5rem;
                color: #555;
            }

            .container-l192 .clause {
                display: flex;
                gap: 1rem;
                margin-bottom: 1rem;
                align-items: flex-start;
            }

            .container-l192 .clause-num {
                min-width: 2.5rem;
                font-weight: normal;
                flex-shrink: 0;
            }

            .container-l192 .fee-section {
                margin: 1.25rem 0 1.25rem 2rem;
            }

            .container-l192 .fee-section h2 {
                font-size: 1.1rem;
                font-weight: bold;
                margin-bottom: 0.75rem;
            }

            .container-l192 .fee-item {
                display: flex;
                gap: 1rem;
                margin-bottom: 0.75rem;
                align-items: flex-start;
            }

            .container-l192 .fee-item-num {
                min-width: 2rem;
                flex-shrink: 0;
            }`}
        </style>
      </Helmet>
      <div className="container-l192">
        <div style={{ fontFamily: `"Hanuman"` }}>
          <h1 style={{ fontFamily: `"Hanuman"` }}>កិច្ចព្រមព្រៀងប្រើប្រាស់ប្រព័ន្ធសម្រាប់អ្នកលក់</h1>
          <p className="version" style={{ fontFamily: `"Hanuman"` }}>
            កំណែ 2026.02.01
          </p>

          <p style={{ fontFamily: `"Hanuman"` }}>
            នៅក្នុងកិច្ចព្រមព្រៀងនេះ អ្នកប្រើប្រាស់ប្រព័ន្ធដាក់លក់និងផ្សព្វផ្សាយទំនិញ (តាមគេហទំព័រ និងកម្មវិធីទូរស័ព្ទ)
            E-commerce L192 ត្រូវបានហៅថា “អ្នកលក់” យល់ព្រមប្រើប្រាស់ប្រព័ន្ធ E-commerce L192 បង្កើតដោយក្រុមហ៊ុន Little
            Digital (Cambodia) Co., Ltd និង យល់ព្រមទទួលលក្ខខណ្ឌដូចខាងក្រោម៖
          </p>

          <table className="table table-bordered">
            <tbody>
              {list.map((item, index) => {
                const str = item.split("-");
                const countStr = str.length;
                return (
                  <tr key={index}>
                    <td style={{ fontFamily: `"Hanuman"` }}>{khmerNumber[index]}</td>
                    <td style={{ fontFamily: `"Hanuman"` }}>
                      {countStr > 1 ? str.at(0) : item}
                      {countStr > 1 ? (
                        <ul style={{ margin: 0, paddingLeft: "1rem" }}>
                          {str.slice(1).map((subItem, subIndex) => {
                            if (subIndex === countStr - 2) return null;
                            return (
                              <li key={subIndex} style={{ fontFamily: `"Hanuman"` }}>
                                {subItem}
                              </li>
                            );
                          })}
                        </ul>
                      ) : null}
                      {countStr > 1 ? str.at(countStr - 1) : item}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <h1>STANDARD SELLER AGREEMENT</h1>
        <p className="version">Version 2026.02.01</p>

        <p>
          In this agreement, as a user of the platforms (web and app), you hereinafter are <strong>SELLER</strong>.
          Little Digital (Cambodia) Co., Ltd develops, maintains, and promotes the platforms and hereinafter is{" "}
          <strong>PLATFORM</strong>. SELLER and PLATFORM agree on the following terms and conditions:
        </p>

        <div className="clause">
          <span className="clause-num">(1)</span>
          <p>SELLER shall provide PLATFORM with correct and true information regarding SELLER's profile.</p>
        </div>

        <div className="clause">
          <span className="clause-num">(2)</span>
          <p>This agreement is continuous until there is an update to the agreement by PLATFORM.</p>
        </div>

        <div className="clause">
          <span className="clause-num">(3)</span>
          <p>
            SELLER agrees to list products on PLATFORM's web and app through PLATFORM's tools. SELLER shall do as
            specified by PLATFORM's tools to upload products and prepare orders within one business hour if SELLER keeps
            its products at its site.
          </p>
        </div>

        <div className="clause">
          <span className="clause-num">(4)</span>
          <p>
            SELLER's products must be legal by laws in Cambodia. SELLER shall have the right to distribute its products
            in Cambodia and own the intellectual property of its products. PLATFORM is not responsible for any action or
            claim by a third party against SELLER. PLATFORM has the right to remove SELLER's products from its platforms
            and facilities if there is any legitimate claim or action against SELLER. PLATFORM also has the right to
            disapprove any SELLER's product if PLATFORM finds the product inappropriate for its platforms.
          </p>
        </div>

        <div className="clause">
          <span className="clause-num">(5)</span>
          <p>
            SELLER controls pricing of its own products. However, PLATFORM has the right to disapprove of pricing deemed
            unreasonable. PLATFORM can determine the maximum Offer Price for a particular product.
          </p>
        </div>

        <div className="clause">
          <span className="clause-num">(6)</span>
          <p>
            If the weight and dimensions of SELLER's product on PLATFORM are different from the actual weight and
            dimensions, PLATFORM charges SELLER for additional delivery cost. PLATFORM uses its delivery cost calculator
            to determine the delivery cost.
          </p>
        </div>

        <div className="clause">
          <span className="clause-num">(7)</span>
          <p>
            If SELLER stores inventory at PLATFORM's fulfillment facilities, PLATFORM is responsible for loss of and
            damage to SELLER's inventory. PLATFORM shall pay for the loss and damage at negotiated prices. However,
            PLATFORM is not responsible for reasonable wear and tear due to product storage or display. Before sending
            inventory to PLATFORM, SELLER must create a shipment using PLATFORM's tools. PLATFORM cannot process any
            inventory shipped by SELLER without a shipment record created by SELLER. PLATFORM shall inform SELLER of the
            shipment discrepancy. If SELLER wants to remove inventory from PLATFORM, SELLER must create a removal
            request. PLATFORM has the right to remove products which have become unusable because of illegality, defect,
            damage, overdue expiry date, and other reasons beyond our control. Due to complexity of PLATFORM's inventory
            storing method, counting inventory at PLATFORM's facilities is not possible. Storage facilities are
            naturally ventilated but not air-conditioned.
          </p>
        </div>

        <div className="clause">
          <span className="clause-num">(8)</span>
          <div>
            <p>
              PLATFORM is an intermediary which connects sellers, buyers, operators, and drivers to ensure the process
              of buying, selling, and fulfillment is 100% safe and most convenient for all the parties involved. As an
              intermediary, PLATFORM is responsible for (a) charging buyers and accepting payments from buyers, and (b)
              disbursing payments to sellers and operators involved less its fees. SELLER agrees that the{" "}
              <strong>Seller Offer Price (SOP)</strong> is the value the seller will receive from PLATFORM, minus the
              pickup fee if applicable, if the product is sold. SELLER agrees that the{" "}
              <strong>App Offer Price (AOP)</strong> input for any product in PLATFORM includes the product price and
              all the relevant fees except the delivery fee. The following list describes PLATFORM's fees.
            </p>

            <div className="fee-section">
              <h2 className="text-left">PLATFORM Fee</h2>

              <div className="fee-item">
                <span className="fee-item-num">1.</span>
                <p>
                  <strong>Technology and service fee.</strong> PLATFORM charges BUYER 15% of SOP for its technology.
                </p>
              </div>

              <div className="fee-item">
                <span className="fee-item-num">2.</span>
                <p>
                  <strong>Unit handling fee.</strong> PLATFORM charges BUYER $0.25/unit for checking, picking, and
                  packing orders.
                </p>
              </div>

              <div className="fee-item">
                <span className="fee-item-num">3.</span>
                <p>
                  <strong>Unit pickup fee.</strong> PLATFORM charges SELLER $0.3/unit for picking up the order SELLER
                  prepares for the buyer at SELLER's site.
                </p>
              </div>

              <div className="fee-item">
                <span className="fee-item-num">4.</span>
                <p>
                  <strong>Inventory storage fee.</strong> PLATFORM charges SELLER $0.5/cubic meter/day as they maintain
                  storage facilities. This fee is applicable if SELLER stores products at PLATFORM's facilities or
                  partner facilities.
                </p>
              </div>

              <div className="fee-item">
                <span className="fee-item-num">5.</span>
                <p>
                  <strong>Inventory processing fee.</strong> PLATFORM charges SELLER $0.05/unit because they unpack the
                  shipment, verify the dimensions and weight of each product, label each unit, and store each unit on
                  shelves. PLATFORM posts this charge when operators successfully process the shipment. This fee is
                  applicable if SELLER stores products at PLATFORM's facilities or partner facilities.
                </p>
              </div>

              <div className="fee-item">
                <span className="fee-item-num">6.</span>
                <p>
                  <strong>Inventory removal fee.</strong> PLATFORM charges SELLER $0.05/unit because they collect all
                  the units from shelves, pack the units, and send them to SELLER. PLATFORM posts this charge when
                  operators successfully process the removal. This fee is applicable if SELLER stores products at
                  PLATFORM's facilities or partner facilities.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="clause">
          <span className="clause-num">(9)</span>
          <p>SELLER automatically agrees to fees and charges by PLATFORM above.</p>
        </div>

        <div className="clause">
          <span className="clause-num">(10)</span>
          <p>
            Payments from buyers are available for disbursement in 10 days after delivery since buyers have a five-day
            period to return products which do not satisfy them. PLATFORM processes any disbursement within 7 working
            days after request.
          </p>
        </div>

        <div className="clause">
          <span className="clause-num">(11)</span>
          <p>
            PLATFORM wants buyers to receive products that satisfy them. However, to prevent fraudulent returns,
            PLATFORM requires buyers to take a picture or video to prove that the product has issues before PLATFORM
            accepts any return.
          </p>
        </div>

        <div className="clause">
          <span className="clause-num">(12)</span>
          <p>
            SELLER shall log into PLATFORM's tools to request disbursement before PLATFORM can process the disbursement.
          </p>
        </div>

        <div className="clause">
          <span className="clause-num">(13)</span>
          <p>
            SELLER is responsible for reporting tax-related information and paying taxes to the relevant tax authority
            in Cambodia if applicable. PLATFORM assumes that SELLER includes VAT in prices set by SELLER. PLATFORM only
            acts as an intermediary among buyers, sellers, operators, and drivers. PLATFORM can only issue a tax invoice
            to SELLER monthly for its charge share only. SELLER shall recognize the disbursed amount (e.g., $7.95) as
            its sales as the base for tax purposes.
          </p>
        </div>

        <div className="clause">
          <span className="clause-num">(14)</span>
          <p>
            PLATFORM has the right to close SELLER's store on its platforms, terminate this agreement, remove and
            discard SELLER's products in PLATFORM's facilities or partner facilities, and seize SELLER's balance to
            settle any charge from PLATFORM if SELLER (a) lists illegal products, (b) fails to settle any payment for
            three months, (c) or is inactive for more than 12 months. If SELLER's balance is not enough to settle any
            charge from PLATFORM, PLATFORM can seize and sell off SELLER's inventory.
          </p>
        </div>

        <div className="clause">
          <span className="clause-num">(15)</span>
          <p>
            PLATFORM shall write off SELLER's account payable and account receivable if SELLER has not requested
            disbursement or settlement of such accounts for a continuous period longer than two (2) years. After this
            period, SELLER forfeits any claim to the written-off balances, and PLATFORM shall have no further obligation
            to disburse or collect such amounts.
          </p>
        </div>
      </div>
    </Content>
  );
}
